<form [formGroup]="form"
  [ngClass]="{'create-mode' : createNewMode, 'edit-mode': !createNewMode}"
>
  <div>
    <header>
      @if (initialized) {
        <div class="buttons">
            <button [matButton]="readonly ? 'filled' : 'outlined'"
                    type="button"
                    class="actionbutton"
                    data-qa="cancel-button"
                    (click)="closeSideNav()">
                <mat-icon svgIcon="innogy_picto_close"></mat-icon>
                {{ (createNewMode || form.dirty) ? 'Abbrechen' : 'Schließen' }}
            </button>

            @if (!readonly) {
                @if (!createNewMode) {
                    <button matButton="outlined"
                            type="reset"
                            data-qa="reset-button"
                            class="actionbutton"
                            (click)="resetForm()"
                            [disabled]="!form.dirty">
                        <mat-icon>autorenew</mat-icon>
                        Zurücksetzen
                    </button>
                }
                @if (!createNewMode) {
                    <button matButton="filled"
                            type="button"
                            class="actionbutton"
                            (click)="saveOrCreateErzeugungsanlage()"
                            data-qa="save-button"
                            [disabled]="isSaveButtonDisabled()">
                        <mat-icon>save</mat-icon>
                        Speichern
                    </button>
                }
                @if (createNewMode) {
                    <button matButton="filled"
                            type="button"
                            color="primary"
                            class="actionbutton"
                            (click)="saveOrCreateErzeugungsanlage()"
                            data-qa="create-button"
                            [disabled]="isCreateButtonDisabled()">
                        <mat-icon>save</mat-icon>
                        Erstellen
                    </button>
                }
                <button (click)="markAllAsTouched()"
                        [disabled]="form.valid"
                        matButton="filled"
                        type="button"
                        class="actionbutton button-warn"
                        data-qa="count-invalid-input-fields"
                        [class.custom-warn]="errorCount > 0">
                    ({{ errorCount }}) Fehler
                </button>
                @if (showDeleteButton) {
                    <button matButton="filled"
                            type="button"
                            data-qa="delete-button"
                            class="actionbutton button-warn"
                            (click)="deleteErzeugungsanlage()">
                        <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
                        Löschen
                    </button>
                }
            }
        </div>
          <div class="dokumentenId">
              <div>Dokumenten-ID:</div>
              <span class="dokumentenId-title" data-qa="dokumenten-id">
          @if (!createNewMode) {
              <span>{{ erzeugungsanlage?.dokumentenId }}</span>
          }
                  @if (createNewMode) {
                      <span>wird automatisch gesetzt</span>
                  }
        </span>
          </div>
      }

    </header>

    <mat-divider class="header-divider"></mat-divider>

      <div fxLayout="row">
        <div class="anchor-menu-container">
          <div class="anchor-menu">
              <ng-container *ngTemplateOutlet="anchorTemplate;context:{anchors:ANCHORS,level:1}"></ng-container>
          </div>
        </div>

          <div class="container">
              <mat-divider inset vertical></mat-divider>

              <div class="detail-main" fxFlex fxLayout="column" fxLayoutGap="3rem">

                  <div fxLayout="column">
                      @if (getAnchor(0); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>

                          <mat-card-content class="flex-wrap">
                              <mat-form-field>
                                  <redispatch-erzeugungsanlage-form-prefix [feld]="Feld.FIELD_GUELTIG_AB"
                                                                           matPrefix>
                                  </redispatch-erzeugungsanlage-form-prefix>
                                  <mat-label>Gültig ab</mat-label>
                                  <input formControlName="gueltigAb"
                                         data-qa="gueltig-ab"
                                         [max]="TODAY_EOB"
                                         [matDatepicker]="datepicker"
                                         matInput
                                         name="gueltigAb"
                                         (focus)="datepicker.open()"/>
                                  <mat-datepicker-toggle matSuffix [for]="datepicker"
                                                         data-qa="gueltig-ab-datepicker-toggle">
                                    <mat-icon matDatepickerToggleIcon svgIcon="innogy_picto_calendar-date-year"></mat-icon>
                                  </mat-datepicker-toggle>
                                  <mat-datepicker #datepicker [id]="'test'"></mat-datepicker>
                                  @if (f.gueltigAb.hasError('required')) {
                                      <mat-error>
                                          Bitte geben Sie ein "Gültig ab" Datum an.
                                      </mat-error>
                                  }
                                  @if (f.gueltigAb.hasError('matDatepickerMax')) {
                                      <mat-error>
                                          Das datum muss heute oder früher sein.
                                      </mat-error>
                                  }
                              </mat-form-field>

                              <mat-form-field redispatchProvideReadonly data-qa="verguetungsart-form-field">
                                  <redispatch-erzeugungsanlage-form-prefix [feld]="Feld.FIELD_VERGUETUNGSART"
                                                                           matPrefix>
                                  </redispatch-erzeugungsanlage-form-prefix>
                                  <mat-label>Fördermodell</mat-label>
                                  <mat-select data-qa="verguetungsart"
                                              formControlName="verguetungsart"
                                              name="sr_verguetungsart">
                                      @for (item of VerguetungsartItems; track item.key) {
                                          <mat-option
                                              data-qa="verguetungsart-option"
                                              [value]="item.key">{{ item.description }}
                                          </mat-option>
                                      }
                                  </mat-select>
                                  @if (f.verguetungsart.hasError('required')) {
                                      <mat-error>
                                          Bitte geben Sie ein Fördermodell an.
                                      </mat-error>
                                  }
                              </mat-form-field>

                              <mat-form-field redispatchProvideReadonly>
                                  <redispatch-erzeugungsanlage-form-prefix [feld]="Feld.FIELD_ANLAGENSCHLUESSEL"
                                                                           matPrefix>
                                  </redispatch-erzeugungsanlage-form-prefix>
                                  <mat-label>EEG-Anlagenschlüssel</mat-label>
                                  <input formControlName="anlagenschluessel"
                                         matInput
                                         name="anlagenschluessel">
                                  @if (f.anlagenschluessel.hasError('required')) {
                                      <mat-error>
                                          Bitte vergeben Sie einen Anlagenschlüssel.
                                      </mat-error>
                                  }
                                  @if (f.anlagenschluessel.getError('maxlength'); as error) {
                                      <mat-error>
                                          Der Anlagenschlüssel darf nicht länger als {{ error.requiredLength }} Zeichen sein.
                                      </mat-error>
                                  }
                                  @if (f.anlagenschluessel.hasError('pattern')) {
                                      <mat-error>
                                          Bitte vergeben Sie einen gültigen EEG-Anlagenschlüssel.
                                      </mat-error>
                                  }
                                  @if (f.anlagenschluessel.hasError('anlagenschluessel')) {
                                      <mat-error>
                                          Dieser Anlagenschlüssel wird bereits verwendet.
                                      </mat-error>
                                  }
                              </mat-form-field>

                              <mat-form-field redispatchProvideReadonly data-qa="energietraeger-form-field">
                                  <redispatch-erzeugungsanlage-form-prefix [feld]="Feld.FIELD_ENERGIETRAEGER"
                                                                           matPrefix>
                                  </redispatch-erzeugungsanlage-form-prefix>
                                  <mat-label>Energieträger</mat-label>
                                  <mat-select
                                      data-qa="energietraeger"
                                      formControlName="energietraeger"
                                      name="energietraeger">
                                      @for (energietraeger of EnergietraegerItems; track energietraeger.key) {
                                          <mat-option
                                              data-qa="energietraeger-option"
                                              [value]="energietraeger.key">{{ energietraeger.description }}
                                          </mat-option>
                                      }
                                  </mat-select>
                                  @if (f.energietraeger.hasError('required')) {
                                      <mat-error>
                                          Bitte vergeben Sie einen eindeutigen Energieträger
                                      </mat-error>
                                  }
                              </mat-form-field>

                              <mat-form-field redispatchProvideReadonly>
                                  <redispatch-erzeugungsanlage-form-prefix [feld]="Feld.FIELD_BEZ_VNB_INTERN"
                                                                           matPrefix>
                                  </redispatch-erzeugungsanlage-form-prefix>
                                  <mat-label>Bezeichnung VNB intern</mat-label>
                                  <input [maxlength]="VNB_INTERN_MAX_LENGTH"
                                         data-qa="bezVnbIntern"
                                         formControlName="bezVnbIntern"
                                         matInput
                                         name="bezVnbIntern">
                              </mat-form-field>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div fxLayout="column">
                      @if (getAnchor(1); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content>
                              <redispatch-netzzuordnung-sub-form [readonly]="readonly"
                                                                 [stadtwerkeId]="stadtwerkeId">
                              </redispatch-netzzuordnung-sub-form>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div fxLayout="column">
                      @if (getAnchor(2); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content fxLayout="column" fxLayoutGap="1rem">
                              <redispatch-anlagen-anschrift-sub-form>
                              </redispatch-anlagen-anschrift-sub-form>

                              <redispatch-geokoordinaten-sub-form [readonly]="readonly">
                              </redispatch-geokoordinaten-sub-form>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div formGroupName="leistung" fxLayout="column">
                      @if (getAnchor(3); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content class="flex-wrap">
                              <mat-form-field redispatchProvideReadonly>
                                  <redispatch-erzeugungsanlage-form-prefix [feld]="Feld.FIELD_BRUTTO_NENNLEISTUNG"
                                                                           matPrefix>
                                  </redispatch-erzeugungsanlage-form-prefix>
                                  <mat-label>Bruttonennleistung [kW]</mat-label>
                                  <input data-qa="bruttonennleistung"
                                         formControlName="bruttonennleistung"
                                         matInput
                                         name="bruttonennleistung"
                                         type="number">
                                  @if (fLeistung.bruttonennleistung.hasError('required')) {
                                      <mat-error>
                                          Bitte vergeben Sie eine Bruttonennleistung
                                      </mat-error>
                                  }
                                  @if (fLeistung.bruttonennleistung.hasError('max')) {
                                      <mat-error>
                                          Maximal 999999,999.
                                      </mat-error>
                                  }
                                  @if (fLeistung.bruttonennleistung.hasError('pattern') && !fLeistung.bruttonennleistung.hasError('max')) {
                                      <mat-error
                                      >
                                          Maximal 3 Nachkommastellen.
                                      </mat-error>
                                  }
                              </mat-form-field>

                              <mat-form-field redispatchProvideReadonly data-qa="blindleistungsverfahren-form-field">
                                  <redispatch-erzeugungsanlage-form-prefix [feld]="Feld.FIELD_BLINDLEISTUNGSVERFAHREN"
                                                                           matPrefix>
                                  </redispatch-erzeugungsanlage-form-prefix>
                                  <mat-label>Blindleistungsverfahren</mat-label>
                                  <mat-select data-qa="blindleistungsverfahren"
                                              formControlName="blindleistungsverfahren"
                                              name="blindleistungsverfahren">
                                      @for (item of BlindleistungsverfahrenItems; track item.key) {
                                          <mat-option
                                              data-qa="blindleistungsverfahren-option"
                                              [value]="item.key">
                                              {{ item.description }}
                                          </mat-option>
                                      }
                                  </mat-select>
                                  @if (fLeistung.blindleistungsverfahren.hasError('required')) {
                                      <mat-error>
                                          Bitte vergeben Sie ein Blindleistungsverfahren
                                      </mat-error>
                                  }
                              </mat-form-field>
                              <div fxFlex="25"> <!-- placeholder --> </div>
                              <div fxFlex="25"> <!-- placeholder --> </div>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div fxLayout="column">
                      @if (getAnchor(4); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content>
                              <redispatch-abregelung-sub-form
                                  [readonly]="readonly"
                                  [erzeugungsanlage]="erzeugungsanlage"
                                  [energietraeger]="f.energietraeger.value"
                                  [steuerbareAbregelungRequired]="isSteuerbareAbregelungRequired"
                              >
                              </redispatch-abregelung-sub-form>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div fxLayout="column">
                      @if (getAnchor(5); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content>
                              <redispatch-resource-ids-sub-form
                                  [readonly]="readonly"
                                  [dokumentenId]="erzeugungsanlage?.dokumentenId"
                                  [netzzuordnungId]="netzzuordnungId"
                                  [funkrundsteuerEmpfaengerInformationen]="funkrundsteuerEmpfaengerInformationen$ | async"
                                  [abregelmoeglichkeit]="abregelmoeglichkeit">
                              </redispatch-resource-ids-sub-form>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div>
                      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                          <mat-checkbox
                              color="primary"
                              data-qa="redispatchrelevant-checkbox"
                              formControlName="redispatchRelevant"
                              name="redispatchRelevant">Anlage ist Redispatch relevant (wird automatisch anhand gebuchter Dienstleistung und Abregelmöglichkeit gesetzt)
                          </mat-checkbox>
                          <redispatch-erzeugungsanlage-form-prefix [feld]="Feld.FIELD_REDISPATCH_RELEVANT"
                                                                   tooltipPosition="right">
                          </redispatch-erzeugungsanlage-form-prefix>
                      </div>
                      @if (redispatchRelevantFlagAutoFixed) {
                          <p class="redispatch-auto-fixed-hint">
                              Wert wurde automatisch korrigiert, Speichern der Anlage notwendig!
                          </p>
                      }
                  </div>

                  <div fxLayout="column">
                      @if (getAnchor(6); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content>
                              <redispatch-steuerbare-resource-sub-form [disabled]="isNotRedispatchRelevant"
                                                                       [readonly]="readonly">
                              </redispatch-steuerbare-resource-sub-form>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div fxLayout="column">
                      @if (getAnchor(7); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content>
                              <redispatch-technische-resource-sub-form [disabled]="isNotRedispatchRelevant"
                                                                       [readonly]="readonly">
                              </redispatch-technische-resource-sub-form>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div fxLayout="column">
                      @if (getAnchor(7,0); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content>
                              <redispatch-marktlokation-sub-form [disabled]="isNotRedispatchRelevant"
                                                                 [readonly]="readonly">
                              </redispatch-marktlokation-sub-form>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div fxLayout="column">
                      @if (getAnchor(7,1); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content>
                              <redispatch-tranche-sub-form [disabled]="isNotRedispatchRelevant"
                                                           [readonly]="readonly">
                              </redispatch-tranche-sub-form>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div fxLayout="column">
                      @if (getAnchor(7,2); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content>
                              <redispatch-betrieb-sub-form [disabled]="isNotRedispatchRelevant"
                                                           [readonly]="readonly">
                              </redispatch-betrieb-sub-form>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div formGroupName="leistung" fxLayout="column">
                      @if (getAnchor(7,3); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content fxLayout="column" fxLayoutGap="1rem">
                              <div class="flex-wrap">
                                  <mat-form-field redispatchProvideReadonly>
                                      <redispatch-erzeugungsanlage-form-prefix
                                          [disabled]="!readonly && isNotRedispatchRelevant"
                                          [feld]="Feld.FIELD_NETTO_NENNLEISTUNG_PROD"
                                          matPrefix>
                                      </redispatch-erzeugungsanlage-form-prefix>
                                      <mat-label>Nettonennleistung Produktion [kW]</mat-label>
                                      <input [redispatchDisableControl]="isNotRedispatchRelevant || readonly"
                                             formControlName="nettonennleistungProduktion"
                                             matInput
                                             name="nettonennleistungProduktion"
                                             type="number">
                                      @if (fLeistung.nettonennleistungProduktion.hasError('max')) {
                                          <mat-error>
                                              Maximal 999999,999.
                                          </mat-error>
                                      }
                                      @if (fLeistung.nettonennleistungProduktion.hasError('pattern') && !fLeistung.nettonennleistungProduktion.hasError('max')) {
                                          <mat-error
                                          >
                                              Maximal 3 Nachkommastellen.
                                          </mat-error>
                                      }
                                  </mat-form-field>

                                  <mat-form-field redispatchProvideReadonly>
                                      <redispatch-erzeugungsanlage-form-prefix
                                          [disabled]="!readonly && (isNotRedispatchRelevant || !isBatterie)"
                                          [feld]="Feld.FIELD_NETTO_NENNLEISTUNG_VERBRAUCH"
                                          matPrefix>
                                      </redispatch-erzeugungsanlage-form-prefix>
                                      <mat-label>Nettonennleistung Verbrauch [kW]</mat-label>
                                      <input
                                          [redispatchDisableControl]="isNotRedispatchRelevant || !isBatterie || readonly"
                                          [required]="isBatterie"
                                          formControlName="nettonennleistungVerbrauch"
                                          matInput
                                          name="nettonennleistungVerbrauch"
                                          type="number">
                                      @if (fLeistung.nettonennleistungVerbrauch.hasError('required')) {
                                          <mat-error>
                                              Bitte geben Sie eine Nettonennleistung Verbrauch [kW] ein.
                                          </mat-error>
                                      }
                                      @if (fLeistung.nettonennleistungVerbrauch.hasError('max')) {
                                          <mat-error>
                                              Maximal 999999,999.
                                          </mat-error>
                                      }
                                      @if (fLeistung.nettonennleistungVerbrauch.hasError('pattern') && !fLeistung.nettonennleistungVerbrauch.hasError('max')) {
                                          <mat-error
                                          >
                                              Maximal 3 Nachkommastellen.
                                          </mat-error>
                                      }
                                  </mat-form-field>
                              </div>

                              <div class="flex-wrap">
                                  <mat-form-field redispatchProvideReadonly>
                                      <redispatch-erzeugungsanlage-form-prefix
                                          [disabled]="!readonly && isNotRedispatchRelevant"
                                          [feld]="Feld.FIELD_NETTO_ENGPASSLEISTUNG_PROD"
                                          matPrefix>
                                      </redispatch-erzeugungsanlage-form-prefix>
                                      <mat-label>Nettoengpassleistung Produktion [kW]</mat-label>
                                      <input [redispatchDisableControl]="isNotRedispatchRelevant || readonly"
                                             formControlName="nettoengpassleistungProduktion"
                                             matInput
                                             name="nettoengpassleistungProduktion"
                                             type="number">
                                      @if (fLeistung.nettoengpassleistungProduktion.hasError('max')) {
                                          <mat-error>
                                              Maximal 999999,999.
                                          </mat-error>
                                      }
                                      @if (fLeistung.nettoengpassleistungProduktion.hasError('pattern') && !fLeistung.nettoengpassleistungProduktion.hasError('max')) {
                                          <mat-error
                                          >
                                              Maximal 3 Nachkommastellen.
                                          </mat-error>
                                      }
                                  </mat-form-field>

                                  <mat-form-field redispatchProvideReadonly>
                                      <redispatch-erzeugungsanlage-form-prefix
                                          [disabled]="!readonly && (isNotRedispatchRelevant || !isBatterie)"
                                          [feld]="Feld.FIELD_NETTO_ENGPASSLEISTUNG_VERBRAUCH"
                                          matPrefix>
                                      </redispatch-erzeugungsanlage-form-prefix>
                                      <mat-label>Nettoengpassleistung Verbrauch [kW]</mat-label>
                                      <input
                                          [redispatchDisableControl]="isNotRedispatchRelevant || !isBatterie || readonly"
                                          [required]="isBatterie"
                                          formControlName="nettoengpassleistungVerbrauch"
                                          matInput
                                          name="nettoengpassleistungVerbrauch"
                                          type="number">
                                      @if (fLeistung.nettoengpassleistungVerbrauch.hasError('required')) {
                                          <mat-error>
                                              Bitte geben Sie eine Nettoengpassleistung Verbrauch [kW] ein.
                                          </mat-error>
                                      }
                                      @if (fLeistung.nettoengpassleistungVerbrauch.hasError('max')) {
                                          <mat-error>
                                              Maximal 999999,999.
                                          </mat-error>
                                      }
                                      @if (fLeistung.nettoengpassleistungVerbrauch.hasError('pattern') && !fLeistung.nettoengpassleistungVerbrauch.hasError('max')) {
                                          <mat-error
                                          >
                                              Maximal 3 Nachkommastellen.
                                          </mat-error>
                                      }
                                  </mat-form-field>
                              </div>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div fxLayout="column">
                      @if (getAnchor(7,4); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content>
                              <redispatch-abrechnung-sub-form [disabled]="isNotRedispatchRelevant"
                                                              [readonly]="readonly">
                              </redispatch-abrechnung-sub-form>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div fxLayout="column">
                      @if (getAnchor(7,5); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content>
                              <redispatch-solar-sub-form [disabled]="isNotRedispatchRelevant || !isSolar"
                                                         [readonly]="readonly"
                                                         [isSpitzOrSpitzLight]="isSpitzOrSpitzLight"
                                                         [spitzOrSpitzLightHint]="spitzOrSpitzLightHint"
                                                         absenkung70Hint="Wird durch die Abregelmöglichkeit unter Steuerung gesetzt">
                              </redispatch-solar-sub-form>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div fxLayout="column">
                      @if (getAnchor(7,6); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content>
                              <redispatch-wind-sub-form [anlagenkennlinieRequired]="isAnlagenkennlinieRequired"
                                                        [disabled]="isNotRedispatchRelevant || !isWind"
                                                        [isWindAnlage]="isWind"
                                                        [readonly]="readonly">
                              </redispatch-wind-sub-form>
                          </mat-card-content>
                      </mat-card>
                  </div>

                  <div fxLayout="column">
                      @if (getAnchor(7,7); as anchor) {
                          <redispatch-form-group-headline
                              [feld]="anchor.label" [id]="anchor.id">
                          </redispatch-form-group-headline>
                      }
                      <mat-card>
                          <mat-card-content>
                              <redispatch-batteriespeicher-sub-form
                                  [disabled]="isNotRedispatchRelevant || !isBatterie"
                                  [readonly]="readonly">
                              </redispatch-batteriespeicher-sub-form>
                          </mat-card-content>
                      </mat-card>
                  </div>

              </div>
          </div>
      </div>

  </div>
</form>

<ng-template #anchorTemplate let-anchors="anchors" let-level="level">
  @for (anchor of anchors; track anchor.id) {
    <button matButton="text"
       class="ml-{{level}}rem button-app-color"
       (click)="navigateToAnchor(anchor.id)"
       (keydown.enter)="navigateToAnchor(anchor.id)"
    >{{ getFeldBeschreibung(anchor.label)?.title }}</button>
    <ng-container *ngTemplateOutlet="anchorTemplate;context:{anchors:anchor.sublevel,level:level+1}"></ng-container>
  }
</ng-template>

